import { createGlobalStyle } from "styled-components";

import IranSans from "../fonts/iran-sans/IRANSansWeb-FaNum.woff2";
import IranSansBold from "../fonts/iran-sans/IRANSans-web-bold.ttf";
import { theme } from "theme";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'IranSans';
    src: url('${IranSans}') format('woff2');
  }
  
  @font-face {
    font-family: 'IranSansBold';
    src: url('${IranSansBold}') format('ttf');
  }

  * {
    font-family: 'IranSans' !important;
  }

  body {
    /* overflow: hidden; */
    direction: rtl;
    margin: 0;
    font-family: 'IranSans', 'Roboto', sans-serif !important;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #root {
    height: 100vh;
  }
  .MuiFormControl-root {
      .MuiFormLabel-root {
        transform-origin: top right !important;
        left: unset !important;
        right: 1.8rem !important;
        font-weight: 500 !important;
      }
      * {
        text-align: right !important;
      }
      
      .MuiOutlinedInput-root {
        border-radius: ${theme.shape.borderRadius}px !important;
        transition: all 0.2s ease-in-out !important;
        
        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        }
        
        &.Mui-focused {
          box-shadow: 0 4px 12px ${theme.palette.primary.main}40 !important;
        }
      }
      
      @media (max-width: 768px) {
        .MuiFormLabel-root {
          font-size: 0.9rem !important;
          right: 1.2rem !important;
        }
        
        .MuiOutlinedInput-root {
          font-size: 1rem !important;
          min-height: 56px !important;
          
          .MuiInputBase-input {
            padding: 16px 14px !important;
            font-size: 1rem !important;
          }
        }
      }
    }

    a {
      text-decoration: none !important;
    }

    .muted-text {
      color: #8c8c8c;
    }

  /* .MuiButtonBase-root {
    color: #fff !important;

    &:disabled {
      color: #00000042 !important;
    }
  } */

  .MuiIconButton-root svg {
    fill: ${theme.palette.text.primary} !important;
  }

  .force-ltr {
    direction: ltr;
  }
  .inline {
    display: inline;
  }

  .css-vnkopk-MuiStepLabel-iconContainer{
    padding-left: 8px;
  }
  .MuiStepLabel-iconContainer text {
    fill: #fff !important;
  }
  .MuiSelect-iconOutlined {
    right: unset !important;
    left: 7px !important;
  }
  .MuiMenuItem-root {
    color: ${theme.palette.text.primary} !important;
  }
  .custom-helper-text {
    color: #f44336;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    margin-top: 3px;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
  }

  .custom-error-label {
    color: #f44336 !important;
  }

  .MuiPickersPopper-root {
    direction: ltr !important;
    
    * {
      color: ${theme.palette.text.primary} !important;
    }

  }
  .MuiDayCalendar-root {
    direction: rtl !important;
  }

  .page-title {
    margin-bottom: ${theme.spacing(5)} !important;
  }

 .MuiOutlinedInput-root .MuiAutocomplete-endAdornment {
  right: unset !important;
  left: 9px !important;
 }

.MuiButton-colorError {
    color: #f44336 !important;
    path {
      fill: #f44336 !important;
    }
 }

 .MuiAlert-icon {
  margin-right: 0 !important;
  margin-left: 12px !important;
 }

 .Toastify__toast {
  direction: rtl !important;
 }

 .rtl-field {
    direction: rtl;
  }

  .MuiPagination-root {
    margin-top: ${theme.spacing(3)};
    direction:ltr;

    .MuiPaginationItem-root {
      &:not(.Mui-selected) {
        color: #000 !important; 
      }
    }
  }

  .MuiAutocomplete-option {
    .MuiSvgIcon-root {
      fill:#000 !important;
    }
  }

  .styled-field {
    input, .MuiSelect-select,.MuiInputBase-root{
      border-radius: ${theme.shape.borderRadius}px;
      background-color: ${theme.palette.background.paper};
      transition: all 0.2s ease-in-out;
    }

    &.file-upload-field {
      .MuiInputBase-formControl {
        background-color: #fff;
      }
    }
    
    .MuiOutlinedInput-root {
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }
      
      &.Mui-focused {
        box-shadow: 0 4px 12px ${theme.palette.primary.main}25;
      }
    }
    
    @media (max-width: 768px) {
      .MuiOutlinedInput-root {
        font-size: 1rem;
        min-height: 56px;
        
        .MuiInputBase-input {
          padding: 16px 14px;
          font-size: 1rem;
        }
      }
    }
  }

  .MuiAlert-root {
    box-shadow: -4px 4px 26px -7px rgba(0,0,0,0.62) !important;
  }

  .hidden-toast {
    display: none !important;
  }

  .MuiButton-colorSuccess {
    &:not(.Mui-disabled) {
      * {fill :#04a504 !important}
    }
  }
  .spacer {
    margin-left: ${theme.spacing(1)};
  }
  .MuiButton-startIcon {
    margin-right: unset !important;
  }
   .MuiChip-icon{
    margin-right: 5px !important;
    margin-left: -6px !important;
  }
.MuiButton-containedError {
  color: ${theme.palette.background.paper} !important;
}
.icon-btn {
  margin-left: ${theme.spacing(2)} !important;
}
.MuiTablePagination-actions {
  direction: ltr;
}
`;
